import styled, { css } from 'styled-components';
import { color, getBackgroundColor, getBorderColor, themeGet } from '@magalu/stereo-ui-styles';
import { typography, space } from 'styled-system';
import Box from '../../../atoms/Box';
export const Container = styled.div.attrs(props => Object.assign({
  bg: 'background.lighter',
  p: 3
}, props))`
  background-color: ${props => getBackgroundColor('white')(props)};
  z-index: ${themeGet('zIndices.2')};
  width: 100%;
  ${props => props.desktopMode && !props.isEmpty && css`
      position: absolute;
      width: inherit;
      top: 34px;
      ${color}
      ${space}
    `}
`;
export const ResultsSuggestionsContainer = styled.div.attrs(props => Object.assign({
  mb: props.isEmpty ? 0 : 3,
  zIndex: 2
}, props))`
  ${space};
`;
export const SuggestionTitle = styled(Box).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'bold',
  color: 'text.primary',
  pb: 2,
  mb: 1
}, props))`
  width: fit-content;
  border-bottom: 1px solid ${getBorderColor('whisper')};

  ${color}
  ${typography}
`;